export default "__VITE_ASSET__7628a371__"